import {Stack} from '@mui/material';
import {bool, object} from 'prop-types';
import React from 'react';
import MoreActionsMenu from './CollectionActions/MoreActionsMenu.jsx';
import ToggleVisibilityButton from './CollectionActions/ToggleVisibilityButton.jsx';
import ZoomToCollectionButton from './CollectionActions/ZoomToCollectionButton.jsx';

const CollectionToolbar = ({collection, hasProducts}) => {
  const hasNoFeatures = collection.feature_count === 0;

  return (
    <Stack spacing={0.5} direction="row">
      <ToggleVisibilityButton
        collection={collection}
        disabled={hasNoFeatures}
      />

      <ZoomToCollectionButton
        collection={collection}
        disabled={hasNoFeatures}
      />
      <MoreActionsMenu collection={collection} hasProducts={hasProducts} />
    </Stack>
  );
};

CollectionToolbar.propTypes = {
  collection: object.isRequired,
  hasProducts: bool,
};

export default CollectionToolbar;
